/**
 * @description
 *
 * Возвращает строку, у которой первый символ преобразовывается в верхний регистр
 *
 * @param {string} str - строка для преобразования
 *
 * @returns {string} - преобразованная строка
 */

const getFirstLetterUpper = (str = '') => str.charAt(0).toUpperCase() + str.slice(1)

export default getFirstLetterUpper
